import sliders from '../../../src/js/shared/sliders';

'use strict';

const $ = jQuery.noConflict();

$(function() {

	const slider = {

		init: function() {
			this.sliderInit();
		},

		sliderInit: function() {

			const $slider = $('.js-slider');

			const $originalSlides = $slider.children().clone();

			for (let i = 0; i < 10; i++) {
				$slider.append($originalSlides.clone());
			}

			const sliderConfig = {
				speed: 8000,
				autoplay: true,
				autoplaySpeed: 0,
				centerMode: false,
				cssEase: 'linear',
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: true,
				infinite: true,
				arrows: false,
				draggable: false,
				pauseOnHover: false,
				pauseOnFocus: false,
				waitForAnimate: false,
				useTransform: true,
				useCSS: true
			};

			// Initialize slider with custom configuration
			sliders.initializeSlider('.js-slider', sliderConfig);
		},

	};

	slider.init();

});
